import type * as Types from '../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveAnalyticsKpiSettingsMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  settings: Types.YalperKpiSettingsInput;
}>;


export type SaveAnalyticsKpiSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveKpiSettings: boolean };


export const SaveAnalyticsKpiSettingsDocument = gql`
    mutation SaveAnalyticsKpiSettings($companyId: ID!, $settings: YalperKpiSettingsInput!) {
  saveKpiSettings(companyId: $companyId, settings: $settings)
}
    `;
export type SaveAnalyticsKpiSettingsMutationFn = Apollo.MutationFunction<SaveAnalyticsKpiSettingsMutationPage, SaveAnalyticsKpiSettingsMutationVariables>;

/**
 * __useSaveAnalyticsKpiSettingsMutation__
 *
 * To run a mutation, you first call `useSaveAnalyticsKpiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAnalyticsKpiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAnalyticsKpiSettingsMutation, { data, loading, error }] = useSaveAnalyticsKpiSettingsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveAnalyticsKpiSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveAnalyticsKpiSettingsMutationPage, SaveAnalyticsKpiSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAnalyticsKpiSettingsMutationPage, SaveAnalyticsKpiSettingsMutationVariables>(SaveAnalyticsKpiSettingsDocument, options);
      }
export type SaveAnalyticsKpiSettingsMutationHookResult = ReturnType<typeof useSaveAnalyticsKpiSettingsMutation>;
export type SaveAnalyticsKpiSettingsMutationResult = Apollo.MutationResult<SaveAnalyticsKpiSettingsMutationPage>;
export type SaveAnalyticsKpiSettingsMutationOptions = Apollo.BaseMutationOptions<SaveAnalyticsKpiSettingsMutationPage, SaveAnalyticsKpiSettingsMutationVariables>;